import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  Popover,
  CircularProgress,
  Button,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { getLogsbyTime, getLogsDetails } from "../network_requests";
import LogsDetails from "../../../constants/LogDetails";

export default function InvitedPeopleLogsTable(props) {
  const allRows = props.rows;
  const [rows, setRows] = useState(allRows);
  const [day, setDays] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [logsDetails, setLogsDetails] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(async () => {
    if (day) {
      setLoad(true);
      const logDetails = await getLogsbyTime(day);
      setLogsDetails(logDetails);
      setLoad(false);
    }
  }, [day]);

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Invitation</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.Invitation}>
                  <TableCell component="th" scope="row">
                    <div
                      onClick={async (event) => {
                        setLoad(true);
                        setLogsDetails([]);
                        setAnchorEl(event.currentTarget);
                        const data = await getLogsDetails(row.Invitation);
                        setLogsDetails(data);
                        setLoad(false);
                      }}
                    >
                      {row.Invitation}
                    </div>
                  </TableCell>
                  <TableCell align="right">{row.count}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TableRow style={{ display: "flex", alignItems: "center" }}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={rows?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(event, page_) => {
              setPage(page_);
            }}
            onChangeRowsPerPage={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />

          <Button
            variant={"contained"}
            color="primary"
            size="small"
            style={{ marginLeft: "5px", fontSize: "10px" }}
            onClick={(event) => {
              setDays(1);
              setAnchorEl(event.currentTarget);
            }}
          >
            1 Day
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: "5px", fontSize: "10px" }}
            onClick={(event) => {
              setDays(7);
              setAnchorEl(event.currentTarget);
            }}
          >
            7 Days
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: "5px", fontSize: "10px" }}
            onClick={(event) => {
              setDays(30);
              setAnchorEl(event.currentTarget);
            }}
          >
            30 Days
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: "5px", fontSize: "10px" }}
            onClick={(event) => {
              setDays(180);
              setAnchorEl(event.currentTarget);
            }}
          >
            6 Months
          </Button>
        </TableRow>
      </TableContainer>
      <Popover
        open={Boolean(anchorEl)}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 20, left: 100 }}
        onClose={() => {
          setAnchorEl(null);
        }}
        style={{ maxWidth: "70%" }}
      >
        {load ? (
          <div
            style={{
              minHeight: "50vh",
              minWidth: "50vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <LogsDetails rows={logsDetails} />
        )}
      </Popover>
    </>
  );
}
